module.exports = __webpack_public_path__ + "static/media/xmr-icon.be7aab3b.svg";